export default function removeIndex<T>(arr: T[], index: number): T[] {
  if (index >= arr.length) return arr;
  return [...arr.slice(0, index), ...arr.slice(index + 1)];
}
